export default __webpack_public_path__ + "static/media/Level28.73f6bb4e.svg";